import { remove, extend, find } from 'lodash';

function Grouping(gettextCatalog, countries) {
  'ngInject';
  /**
   * @ngdoc method
   * @name extendItem
   * @methodOf adjust.service:Grouping
   *
   * @description
   * Extends the result item with a name and token based on the grouping type
   *
   * @param {Object} item
   * @param {string} grouping
   * @param {Array} trackerDefinitions the list of the trackers with names
   *
   * @returns {Object} extended copy of the object
   */
  function extendItem(item, grouping, trackerDefinitions, secretDefinitions) {
    return {
      trackers: function(_item) {
        var [trackerDefinition] = remove(trackerDefinitions, { token: _item.token });

        return extend({}, _item, trackerDefinition);
      },
      dates: function(_item) {
        return extend({}, _item, { name: _item.date, token: _item.date });
      },
      week: function(_item) {
        return extend({}, _item, { name: _item.date, token: _item.date });
      },
      month: function(_item) {
        return extend({}, _item, { name: _item.date, token: _item.date });
      },
      countries: function(_item) {
        var country = find(countries, { code: _item.country }) || { name: _item.country };

        return extend({}, _item, { name: country.name, token: _item.country });
      },
      regions: function(_item) {
        return extend(
          {},
          _item,
          { name: _item.region, token: _item.region, label: _item.region }
        );
      },
      os_names: function(_item) {
        return extend(
          {},
          _item,
          { name: gettextCatalog.getString(_item.os_name), token: _item.os_name }
        );
      },
      platforms: function(_item) {
        return extend({}, _item, { name: _item.platform, token: _item.platform });
      },
      device_types: function(_item) {
        return extend(
          {},
          _item,
          { name: gettextCatalog.getString(_item.device_type), token: _item.device_type }
        );
      },
      secret_ids: function(_item) {
        var name =
          secretDefinitions[_item.secret_id] || gettextCatalog.getString('label.secret-id', { id: _item.secret_id });

        return extend({}, _item, { name: name, token: _item.secret_id });
      },
      partners: function(_item) {
        return extend({}, _item, { name: _item.partner, token: _item.partner });
      },
    }[grouping](item);
  }

  /**
   * @ngdoc method
   * @name extend
   * @methodOf adjust.service:Grouping
   *
   * @description
   * Returns the list of available groupings for the instance
   *
   * @param {string} instance can be overview/cohorts
   * @returns the list of available groupings for the instance
   */
  function get(instance) {
    return {
      overview: [
        { value: 'trackers', label: gettextCatalog.getString('label.tracker') },
        { value: 'dates', label: gettextCatalog.getString('label.date'), hide: 'graph' },
        { value: 'week', label: gettextCatalog.getString('label.week'), hide: 'graph' },
        { value: 'month', label: gettextCatalog.getString('label.month'), hide: 'graph' },
        { value: 'countries', label: gettextCatalog.getString('label.country') },
        { value: 'regions', label: gettextCatalog.getString('label.region') },
        { value: 'os_names', label: gettextCatalog.getString('label.os') },
        { value: 'platforms', label: gettextCatalog.getString('label.platform') },
        { value: 'device_types', label: gettextCatalog.getString('label.device-type') },
        { value: 'partners', label: gettextCatalog.getString('label.partner') },
      ],
      cohorts: [
        { value: 'trackers', label: gettextCatalog.getString('label.tracker') },
        { value: 'dates', label: gettextCatalog.getString('label.date') },
        { value: 'countries', label: gettextCatalog.getString('label.country') },
        { value: 'regions', label: gettextCatalog.getString('label.region') },
        { value: 'os_names', label: gettextCatalog.getString('label.os') },
        { value: 'platforms', label: gettextCatalog.getString('label.platform') },
        { value: 'device_types', label: gettextCatalog.getString('label.device-type') },
        { value: 'partners', label: gettextCatalog.getString('label.partner') },
      ],
      secrets: [
        { value: 'trackers', label: gettextCatalog.getString('label.tracker') },
        { value: 'countries', label: gettextCatalog.getString('label.country') },
        { value: 'secret_ids', label: gettextCatalog.getString('label.secrets'), hide: 'graph' },
      ],
    }[instance];
  }

  return {
    get: get,
    extend: extendItem,
  };
}

export { Grouping };
